import 'modules/carousel-swiper/carousel-swiper-custom'
import 'modules/carousel-swiper/carousel-swiper-register'
import 'modules/hot-spot/hot-spot'
import SearchBar from 'modules/search-bar/search-bar-searchspring'
import register from 'preact-custom-element'
import 'snippets/accordion-list/accordion-list'
import 'snippets/carousel/carousel'
import 'snippets/custom-input-password/custom-input-password'
import 'snippets/modal-dialog/modal-dialog'
import NoticeGlobal from 'snippets/notice-global/notice-global'
import GeolocatorPopup from 'snippets/geolocator-popup/geolocator-popup'
import 'snippets/notice-main/notice-main'
import 'snippets/read-more/read-more'
import 'snippets/slideout/slideout'
import 'snippets/slideout-tabs/slideout-tabs'
import 'snippets/validate-form/validate-form'
import 'snippets/video-player/video-player'
import 'styles/theme.css'
import LazyLoad from 'vanilla-lazyload'
import { isWishlistEnabled } from 'helpers/wishlist'

// window.AOS.init({
//   delay: 0,
//   offset: 100,
//   duration: 500,
//   easing: 'ease-in-sine',
//   mirror: true,
//   placementL: 'top-center',
//   startEvent: 'load'
// })

register(NoticeGlobal, 'notice-global')
register(GeolocatorPopup, 'geolocator-popup')
register(SearchBar, 'search-bar')

window.lazyLoadInstance = new LazyLoad()
window.addEventListener(
  'LazyLoad::Initialized',
  function (e) {
    console.log(e.detail.instance)
  },
  false
)

window.lazyLoadInstance.update()

const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
let topbarCurrentPadding = ''
let menuCurrentPadding = ''
const scrollbarMutation = new MutationObserver(() => {
  if (window.innerWidth >= 1024) {
    const isScrollDisabled = getComputedStyle(document.body).overflow === 'hidden'
    const header = document.querySelector('.site-header')
    const topbar = document.querySelector('.container.js-topbar')
    const megamenu = document.querySelector('.container.mega-menu-container')

    if (topbarCurrentPadding === '') topbarCurrentPadding = topbar ? parseFloat(getComputedStyle(topbar).paddingRight) : 0
    if (menuCurrentPadding === '') menuCurrentPadding = megamenu ? parseFloat(getComputedStyle(megamenu).paddingRight) : 0

    if (isScrollDisabled) {
      document.body.style.paddingRight = `${scrollBarWidth}px`
      if (header) header.style.paddingRight = `${scrollBarWidth}px`
      if (topbar) topbar.style.paddingRight = `${topbarCurrentPadding + scrollBarWidth}px`
      if (megamenu) megamenu.style.paddingRight = `${menuCurrentPadding + scrollBarWidth}px`
    } else {
      document.body.style.paddingRight = ''
      if (header) header.style.paddingRight = ''
      if (topbar) topbar.style.paddingRight = `${topbarCurrentPadding}px`
      if (megamenu) megamenu.style.paddingRight = `${menuCurrentPadding}px`
    }
  }
})

scrollbarMutation.observe(document.body, {
  attributes: true,
  attributeFilter: ['style', 'class']
})

// Wishlist
let plpWishlistClickHandler = null
let wishlistAddHandler = null
let globalSwatInstance = null

function swymCallbackFn(swat) {
  globalSwatInstance = swat
  document.addEventListener('swym:collections-loaded', function() {
    swat.initializeActionButtons('.template')
  })

  setupPlpWishlistRemoval(swat)
  setupWishlistLoginCheck(swat)
}

function setupWishlistLoginCheck(swat) {
  if (wishlistAddHandler) {
    document.removeEventListener('click', wishlistAddHandler, true)
  }

  wishlistAddHandler = (event) => {
    const button = event.target.closest('.swym-button.swym-add-to-wishlist-view-product')

    if (!button) return

    // Only handle clicks when button doesn't have swym-added class yet
    if (button.classList.contains('swym-added')) {
      return
    }

    // Check if customer is logged in
    const isLoggedIn = window.GM_STATE && window.GM_STATE.customer && window.GM_STATE.customer.logged

    if (!isLoggedIn) {
      event.preventDefault()
      event.stopPropagation()
      event.stopImmediatePropagation()

      const productData = {
        epi: Number(button.getAttribute('data-variant-id')),
        empi: Number(button.getAttribute('data-product-id')),
        du: button.getAttribute('data-product-url')
      }

      // Get Swym instance
      const swymInstance = swat || window._swat || globalSwatInstance

      if (swymInstance && typeof swymInstance.addToWishList === 'function') {
        swymInstance.addToWishList(productData, (success) => {
          window.location.href = `/account/login?redirect=${window.location.pathname}`
        }, (error) => {
          console.error('Failed to add to wishlist before redirect:', error)
          window.location.href = `/account/login?redirect=${window.location.pathname}`
        })
      } else {
        // Fallback: redirect without adding if Swym not available
        console.warn('Swym instance not available, redirecting without adding to wishlist')
        window.location.href = `/account/login?redirect=${window.location.pathname}`
      }
    }
  }

  document.addEventListener('click', wishlistAddHandler, true)
}

function handlePlpWishlistClick(swat, event) {
  const button = event.target.closest('.custom-swym-button')

  if (!button) return

  if (button.dataset.removing === 'true') {
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()
    return
  }

  if (button.classList.contains('swym-added')) {
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()

    button.dataset.removing = 'true'

    const originalAttributes = {
      action: button.getAttribute('data-swaction'),
      hadSwymButton: button.classList.contains('swym-button')
    }

    button.removeAttribute('data-swaction')
    button.classList.remove('swym-button')
    button.classList.remove('swym-add-to-wishlist-view-product')

    removeFromWishlist(swat, button, originalAttributes)
  }
}

function setupPlpWishlistRemoval(swat) {
  if (plpWishlistClickHandler) {
    document.removeEventListener('click', plpWishlistClickHandler, true)
  }

  plpWishlistClickHandler = handlePlpWishlistClick.bind(null, swat)
  document.addEventListener('click', plpWishlistClickHandler, true)
}

window.removeFromWishlist = function removeFromWishlist(swat, button, originalAttributes) {
  if (!swat) {
    console.error('Swym is not initialized')
    return
  }

  const product = {
    epi: Number(button.getAttribute('data-variant-id')),
    empi: Number(button.getAttribute('data-product-id')),
    du: button.getAttribute('data-product-url')
  }

  if (!product.epi || !product.empi || !product.du) {
    console.error('Missing required product data for wishlist removal')
    return
  }

  button.disabled = true
  button.style.opacity = '0.5'

  const restoreSwymAttributes = () => {
    if (originalAttributes.action) {
      button.setAttribute('data-swaction', originalAttributes.action)
    }
    if (originalAttributes.hadSwymButton) {
      button.classList.add('swym-button')
      button.classList.add('swym-add-to-wishlist-view-product')
    }
  }

  const performRemoval = (initialListId) => {
    const swymInstance = window._swat || swat

    const allLists = swymInstance.swymCustomWishlistLists || []

    const checkList = (listIndex) => {
      if (listIndex >= allLists.length) {
        handleRemovalError({ description: 'Item not found in any wishlist' })
        return
      }

      const currentList = allLists[listIndex]
      const listId = currentList.lid

      swymInstance.fetchListDetails(
        { lid: listId },
        (listDetails) => {
          if (listDetails?.items && listDetails.items.length > 0) {
            const itemExists = listDetails.items.some(item =>
              item.epi === product.epi && item.empi === product.empi
            )

            if (itemExists) {
              // Found the item! Now perform the actual deletion
              performActualRemoval(swymInstance, listId)
              return
            }
          }

          checkList(listIndex + 1)
        },
        (error) => {
          console.error('Error fetching list details:', error)
          checkList(listIndex + 1)
        }
      )
    }

    checkList(0)
  }

  const performActualRemoval = (swymInstance, listId) => {
    if (swymInstance.deleteFromList && typeof swymInstance.deleteFromList === 'function') {
      swymInstance.deleteFromList(
        listId,
        product,
        (response) => handleRemovalResponse(response),
        (error) => handleRemovalError(error)
      )
    } else if (swymInstance.removeFromWishlist && typeof swymInstance.removeFromWishlist === 'function') {
      swymInstance.removeFromWishlist(
        listId,
        product,
        (response) => handleRemovalResponse(response),
        (error) => handleRemovalError(error)
      )
    } else {
      handleRemovalError({ description: 'Swym removal method not found' })
    }
  }

  const handleRemovalResponse = (response) => {
    if (response && response.hasError) {
      button.disabled = false
      button.style.opacity = ''
      delete button.dataset.removing

      button.classList.add('swym-added')
      restoreSwymAttributes()

      if (swat.ui && swat.ui.showErrorNotification) {
        swat.ui.showErrorNotification({
          message: response.msg || response.error?.description || 'Failed to remove from wishlist'
        })
      }
      return
    }

    button.classList.remove('swym-added')
    button.disabled = false
    button.style.opacity = ''
    button.setAttribute('aria-pressed', 'false')
    delete button.dataset.removing

    // Restore Swym attributes after successful removal
    restoreSwymAttributes()

    if (swat.ui && swat.ui.showSuccessNotification) {
      swat.ui.showSuccessNotification({
        message: '<strong>Product removed from wishlist</strong>'
      })
    }
  }

  const handleRemovalError = (error) => {
    button.disabled = false
    button.style.opacity = ''
    delete button.dataset.removing

    button.classList.add('swym-added')
    restoreSwymAttributes()

    if (swat.ui && swat.ui.showErrorNotification) {
      swat.ui.showErrorNotification({
        message: error.description || 'Failed to remove from wishlist'
      })
    }
  }

  // Check if lists are already loaded
  if (swat.swymCustomWishlistLists && swat.swymCustomWishlistLists.length > 0) {
    const listId = swat.swymCustomWishlistSelectedListId || swat.swymCustomWishlistLists[0].lid
    performRemoval(listId)
  } else {
    // Fetch lists first, then remove
    swat.fetchLists({
      callbackFn: (lists) => {
        if (lists && lists.length > 0) {
          swat.swymCustomWishlistLists = lists
          const listId = swat.swymCustomWishlistSelectedListId || lists[0].lid
          performRemoval(listId)
        } else {
          button.disabled = false
          button.style.opacity = ''
          delete button.dataset.removing
          button.classList.add('swym-added')
          restoreSwymAttributes()
        }
      },
      errorFn: (error) => {
        console.error('Error fetching wishlists:', error)
        button.disabled = false
        button.style.opacity = ''
        delete button.dataset.removing
        button.classList.add('swym-added')
        restoreSwymAttributes()
      }
    })
  }
}

function registerSwymCallbacks() {
  if (!isWishlistEnabled()) return

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = []
  }

  window.SwymCallbacks.push(swymCallbackFn)
}

if (window.GM_STATE?.onReady) {
  window.GM_STATE.onReady(registerSwymCallbacks)
} else {
  registerSwymCallbacks()
}
